import { render, staticRenderFns } from "./historique-protocole-soins.html?vue&type=template&id=1c3d39e2&scoped=true&external"
import script from "./historique-protocole-soins.js?vue&type=script&lang=js&external"
export * from "./historique-protocole-soins.js?vue&type=script&lang=js&external"
import style0 from "./historique-protocole-soins.scss?vue&type=style&index=0&id=1c3d39e2&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c3d39e2",
  null
  
)

export default component.exports